import { apiRequest } from '@/api/client';
import type { IntegrationDetailView, IntegrationKind, IntegrationsView } from '@/types/api';

/** Keys of outside services (ADR-0048): owners and administrators only. */
export const integrationsApi = {
  list: () => apiRequest<IntegrationsView>('/integrations'),
  /** One integration's page (ADR-0052): state, usage, history. */
  detail: (kind: IntegrationKind) => apiRequest<IntegrationDetailView>(`/integrations/${kind}`),
  /** Saves and checks at once: the answer says whether the key works. */
  save: (kind: IntegrationKind, input: Record<string, unknown>) => apiRequest<IntegrationsView>(`/integrations/${kind}`, { method: 'PUT', body: input }),
  check: (kind: IntegrationKind) => apiRequest<IntegrationsView>(`/integrations/${kind}/check`, { method: 'POST', body: {} }),
  remove: (kind: IntegrationKind) => apiRequest<{ removed: boolean }>(`/integrations/${kind}`, { method: 'DELETE' }),
};
